module.exports = {
  path: 'development_and_planting',
  childRoutes: [ require("./2010"), require("./2011"), require("./2012"), require("./2013"), require("./2014") ]
}



// WEBPACK FOOTER //
// ./src/routes/Pictures/DevelopmentAndPlanting/index.js